// native
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize } from 'rxjs/operators';

// addon
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

// service
import { TestsService } from '../../core/services/tests.service';
import { TestBundlesService } from 'app/core/services/test-bundles.service';
import { PreferencesService } from 'app/core/services/preferences.service';
import { MonitorTestService } from 'app/core/services/monitor-test.service';
import { DevicesService } from 'app/core/services/devices.service';
import { AuthService } from 'app/core/services/auth.service';
import { PatientsService } from 'app/core/services/patients.service';
import { StreamingService } from 'app/core/services/streaming.service';
import { DialogService } from 'app/core/services/dialog.service';

// component
import { MonitorBaseComponent } from '../monitor-base.component';

// models
import { DryEyeQuestionnaireRecord, MonitorEvent } from '../../models';

//animation
import { fadeAnimation, startList } from '../../animations/animations';

// constant
import { MONITOR_EVENT_TYPE } from '../../constants';

@Component({
    selector: 'app-dry-eye-questionnaire',
    templateUrl: './monitor-dry-eye-questionnaire.component.html',
    animations: [fadeAnimation, startList],
    standalone: false
})
export class MonitorDryEyeQuestionnaireComponent extends MonitorBaseComponent {
  responses: DryEyeQuestionnaireRecord[] = [];
  answers: number[] = [undefined, undefined, undefined, undefined, undefined, undefined];

  ongoingPercentage: number;

  isLoading: boolean = true;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public testService: TestsService,
    public testBundlesService: TestBundlesService,
    public toastService: ToastrService,
    public devicesService: DevicesService,
    public authService: AuthService,
    public patientsService: PatientsService,
    public monitorTestService: MonitorTestService,
    public streamingService: StreamingService,
    public preferencesService: PreferencesService,
    public translateService: TranslateService,
    public dialogService: DialogService) {
    super(route, router, testService, testBundlesService, toastService, devicesService, authService, patientsService,
      monitorTestService, streamingService, preferencesService, translateService, dialogService);
  }

  public getCurrentTestState() {
    this.monitorTestService.getDryEyeQuestionnaireState(this.test.id)
      .pipe(
        finalize(() => this.isLoading = false)
      ).subscribe(records => {
        this.renderRecords(records);
      });
  }

  private renderRecords(records: DryEyeQuestionnaireRecord[]) {
    for (const record of records) {
      if (record.question >= 1 && record.question <= 6)
        this.answers[record.question - 1] = record.answer;
    }

    let answeredQuestions = 0;
    for (const answer of this.answers) {
      if (answer !== undefined)
        answeredQuestions++;
    }

    this.ongoingPercentage = Math.round(answeredQuestions / 6 * 100);
  }

  public getPercentageDone() {
    return this.isTestDone
      ? 100
      : this.ongoingPercentage;
  }

  public calculateDimensions() { }

  public handleNewRecordEvent(event: MonitorEvent) {
    if (event.type === MONITOR_EVENT_TYPE.NEW_DRY_EYE_QUESTIONNAIRE_RECORD)
      this.updateRecords(<DryEyeQuestionnaireRecord>event.data);
  }

  private updateRecords(record: DryEyeQuestionnaireRecord) {
    this.responses.push(record);
    this.renderRecords(this.responses);
  }

  public resetStateAfterReconnection(): void {
    this.responses = [];
  }

  public onToggleGrid() { }
}